export default "__VITE_ASSET__BliPLWQu__"